import coinbaseLogo from '../assets/images/coinbase.png';

export const COMPANY_LOGOS: Record<string, string> = {
  Coinbase_DEMO: coinbaseLogo,
};
